export default "__VITE_ASSET__uvH12Gzc__"